export default {   
    all: function() {
        return window.axios.get(`forces`);
    },
    get: function (id) {
        return window.axios.get(`forces/${id}`);
    },
    store: function (data) {
        return window.axios.post(`forces`, data, { 
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    update: function (id, data) {
        return window.axios.post(`forces/${id}?_method=PUT`, data, { 
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    destroy: function (id) {
        return window.axios.delete(`forces/${id}`);
    },
    canDelete: function (id) {
        return window.axios.get(`forces/${id}/deletable`);
    },
}